import {PeriodKind} from '../ModelContracts';
import {UsersContemporaneousRepository} from '../repositories/UsersContemporaneousRepository';

export class UsersContemporaneousResultsService {
	constructor(private repo: UsersContemporaneousRepository) {}

	requestUserContemporaneousWithoutNotify = (periodPolicy: string, periodKind: PeriodKind) =>
		this.repo.getAllByWithPeriod(periodPolicy, periodKind);
}
